export default "__VITE_ASSET__DqQHTAO$__"